import { render, staticRenderFns } from "./DefectList.vue?vue&type=template&id=0eb27830&scoped=true&"
import script from "./DefectList.vue?vue&type=script&lang=js&"
export * from "./DefectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb27830",
  null
  
)

export default component.exports